import Question from '../../../components/Question/Question';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamQuestion = ({
  mostRecentExamAttempt,
  onSelectAnswer,
  selectedAnswerIds
}) => {
  const totalQuestionCount = mostRecentExamAttempt ? mostRecentExamAttempt.questions.length : 0;
  const currentQuestionIndex = mostRecentExamAttempt ? Math.max(0, Math.min(mostRecentExamAttempt.questionSubmissions.length, totalQuestionCount - 1)) : 0;
  const currentQuestion = mostRecentExamAttempt && mostRecentExamAttempt.questions[currentQuestionIndex];
  if (!currentQuestion) return null;
  return /*#__PURE__*/_jsx(Question, {
    answers: currentQuestion.answers,
    image: currentQuestion.image,
    imageAlt: currentQuestion.imageAlt,
    onSelectAnswer: onSelectAnswer,
    selectedAnswerIds: selectedAnswerIds,
    type: currentQuestion.questionType
  });
};
export default ExamQuestion;